<div
  class="album-web-container min-h-screen bg-gradient-to-br"
  (keydown)="onKeyDown($event)"
  tabindex="0"
>
  <div class="chapeau-background"></div>
  <div class="container mx-auto px-4 py-6">
    <!-- Titre de la page -->
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 30px 0;
      "
    >
      <app-page-title [titleKey]="'albums.title'"></app-page-title>
    </div>

    <!-- Sélecteur d'enfants -->
    <app-children-selector
      [autoSelectFirst]="true"
      (studentSelected)="onStudentSelected($event)"
      (studentsLoaded)="onStudentsLoaded($event)"
    >
    </app-children-selector>
    <br /><br />
    <!-- Container du carousel -->
    <!-- Container du carousel -->
    <div
      class="relative w-full mb-8"
      (wheel)="onMouseWheel($event)"
      style="perspective: 1000px"
    >
      <!-- Deux cartes côte à côte -->
      <!-- Carousel à 3 images -->
      <div class="relative w-full mb-8 flex justify-center">
        <button
          class="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-[#ccefed] backdrop-blur-md shadow-md flex items-center justify-center transition-all duration-300 hover:bg-[#009A90] hover:scale-110 group"
          (click)="moveToCenter('left')"
        >
          <svg
            class="w-6 h-6 text-[#009A90] group-hover:text-white transition-colors duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button
          class="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-[#ccefed] backdrop-blur-md shadow-md flex items-center justify-center transition-all duration-300 hover:bg-[#009A90] hover:scale-110 group"
          (click)="moveToCenter('right')"
        >
          <svg
            class="w-6 h-6 text-[#009A90] group-hover:text-white transition-colors duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>

        <div class="flex space-x-4 items-start">
          <!-- Image de gauche (petite) -->
          <div
            (click)="goToAlbum(getCenterImage())"
            class="w-64 h-80 bg-white rounded-xl shadow-lg overflow-hidden cursor-pointer carousel-preview transition-all duration-500"
            *ngIf="getLeftImage()"
            (click)="moveToCenter('left')"
          >
            <img
              [src]="getLeftImage()!.src"
              [alt]="getLeftImage()!.alt"
              class="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
              loading="lazy"
            />
          </div>

          <!-- Image centrale (grande) -->
          <div
            (click)="goToAlbum(getCenterImage())"
            class="w-96 h-96 bg-white rounded-xl shadow-xl overflow-hidden relative group cursor-pointer carousel-center-image"
            *ngIf="getCenterImage()"
            [ngClass]="getAnimationClass()"
            style="transition: transform 0.3s ease"
          >
            <img
              [src]="getCenterImage()!.src"
              [alt]="getCenterImage()!.alt"
              class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <!-- Overlay au survol -->
            <div
              class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            ></div>
            <!-- Footer -->
            <div
              class="absolute bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-sm flex justify-between items-center"
            >
              <h3 class="text-sm font-medium text-gray-700">
                {{ getCenterImage()!.creationDate }}
              </h3>

              <h3 class="text-sm font-medium text-gray-700">
                {{ getCenterImage()!.title }}
              </h3>
              <button
                class="w-8 h-8 bg-[#e0f7f1] rounded-full flex items-center justify-center hover:bg-[#b2f5ea] transition-colors duration-200"
                (click)="goToAlbum(getCenterImage())"
                [attr.aria-label]="'albums.viewAlbum' | translate"
              >
                <svg
                  class="w-4 h-4 text-[#009A90]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  ></path>
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7S3.732 16.057 2.458 12z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>

          <!-- Image de droite (petite) -->
          <div
            (click)="goToAlbum(getCenterImage())"
            class="w-64 h-80 bg-white rounded-xl shadow-lg overflow-hidden cursor-pointer carousel-preview transition-all duration-500"
            *ngIf="getRightImage()"
            (click)="moveToCenter('right')"
            [attr.aria-label]="'albums.viewAlbum' | translate"
          >
            <img
              [src]="getRightImage()!.src"
              [alt]="getRightImage()!.alt"
              class="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
              loading="lazy"
            />
            <!-- Bouton œil -->
          </div>
        </div>
      </div>

      <!-- Indicateur de mode d'animation (optionnel, pour le développement) -->
      <!--       <div
        class="flex justify-center mt-4 opacity-50 hover:opacity-100 transition-opacity duration-300"
      >
        <div
          class="text-xs text-gray-600 bg-white/80 px-3 py-1 rounded-full shadow-sm"
        >
          Animation: {{ currentAnimation }} | Direction:
          {{ animationDirection || "none" }}
        </div>
      </div> -->
    </div>
  </div>
</div>
